<template>
  <div>
    <v-btn
      @click="open"
      :icon="iconName"
      size="30"
      class="ma-1"
      text="حذف"
      variant="outlined"
    ></v-btn>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">{{ message }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" variant="text" @click="cancel">لا</v-btn>
          <v-btn color="blue-darken-1" variant="text" @click="confirm"
            >نعم</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "DialogSimp",
  components: {},
  data: () => ({
    dialog: false,
  }),
  props: {
    iconName: String,
    item: {},
    confirmFunction: Function,
    message: String,
    btnText: String,
  },
  methods: {
    confirm() {
      this.confirmFunction(this.item);
      this.dialog = false;
    },
    cancel() {
      this.dialog = false;
    },
    open() {
      this.dialog = true;
    },
  },
};
</script>
